import { toastCopyOperationCatcher, toastSuccessMessage } from "./alerts";
import { rollbarAndLogError } from "./logger";
import { blankInstructorNotesWorksheetData } from "./worksheet";

import { serverCopyTopic } from "api/api-server-actions";
import { PageType, TopicType } from "components/server-types";
import { t } from "i18n/i18n";
import { store, storeApi } from "store/index";

export const topicIdForPage = (
  page: Pick<PageType, "id" | "activity_id"> | undefined,
): string | undefined => {
  if (!page) return undefined;
  const { activities, pages } = store.getState();
  const activityId = page.activity_id ?? pages[page.id]?.activity_id;
  if (!activityId) return undefined;
  return activities[activityId]?.topic_id;
};

export const refreshTopicPageCounts = async (topicId: string | undefined | null) => {
  if (!topicId) return;
  try {
    await storeApi.topics.retrieve(topicId, { skipCache: true });
  } catch (error) {
    rollbarAndLogError("Failed to refresh topic page counts", { topicId, error });
  }
};

const createTopic = (sectionId: string) =>
  storeApi.topics.create({
    section_id: sectionId,
    title: t("common.default.topic"),
    instructor_notes_worksheet_data: blankInstructorNotesWorksheetData(),
  });

const deleteTopic = (topic: TopicType) => storeApi.topics.destroy(topic.id);

const saveTopic = (topic: Partial<TopicType> & { id: string }) =>
  storeApi.topics.partial_update(topic);

const dropTopic = (topic: TopicType) => saveTopic({ id: topic.id, order: topic.order });

const copyTopic = (itemId: string, sectionIds: string[]) =>
  serverCopyTopic(itemId, sectionIds)
    .then(() => {
      toastSuccessMessage(t("content_view.item_copied", { item: t("glossary.topic") }));
    })
    .catch(toastCopyOperationCatcher("topics"));

export const useTopicActions = () => {
  return { createTopic, copyTopic, dropTopic, deleteTopic, saveTopic };
};
